exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable-table th span{cursor:pointer}.sortable-table{box-shadow:0 2px 10px rgba(50,50,50,.15)}.place-holder{visibility:hidden}", ""]);

// exports
